import React, { ChangeEvent, FC, useCallback } from "react";
import { Field } from "../FieldHandler";

const TextareaField: FC<{
  field: Field & { type: "textarea" };
  onChange: (key: string, value: string) => void;
  onBlur?: (field: Field) => void;
}> = ({ field, onChange, onBlur }) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(field.key, e.target.value);
    },
    [onChange, field]
  );

  const handleBlur = useCallback(() => {
    if (!onBlur) {
      return;
    }
    onBlur(field);
  }, [onBlur, field]);

  return (
    <span>
      <textarea value={field.value || ""} placeholder={field.required ? "required" : ""} onChange={handleChange} onBlur={handleBlur} />
    </span>
  );
};

export default TextareaField;
